import _extends from "@babel/runtime/helpers/esm/extends";
// this file has been generated using SVGR.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.604 24.018L8.31 9.725c-.943-.943.471-2.357 1.414-1.414l14.293 14.293L38.311 8.31c.943-.943 2.357.471 1.414 1.414L25.432 24.018l14.293 14.293c.943.943-.471 2.357-1.414 1.414L24.018 25.432 9.725 39.725c-.943.943-2.357-.471-1.414-1.414l14.293-14.293z",
    fill: "currentColor"
  }));
};

var SvgClose = styled(SvgComponent).withConfig({
  displayName: "Close__SvgClose",
  componentId: "hm8qnr-0"
})(["", " ", ""], size, color);
export default SvgClose;